<template>
  <div class="dddiv">
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>加入我们</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form ref="form" :model="contForm">

      <el-form-item label="图一" :rules="[
          { required: true, message: '不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccessone"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="contForm.image_one" alt="">
        </div>
      </el-form-item>

      <el-form-item label="图二" :rules="[
          { required: true, message: '不能为空'},
        ]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          :headers='headers'
          :show-file-list=false
          :on-success="upImgSuccesstwo"
          multiple
          :limit="3">
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
        </el-upload>
        <div class="QR-code">
          <img width="100%" :src="contForm.image_two " alt="">
        </div>
      </el-form-item>
     
     
      <el-form-item label="内容" :rules="[
        { required: true, message: '内容不能为空'},]">
        <el-input type="textarea" placeholder="" v-model="contForm.content"></el-input>
      </el-form-item> 

      <el-form-item label="英文内容" :rules="[
        { required: true, message: '内容不能为空'},]">
        <el-input type="textarea" placeholder="" v-model="contForm.content_en"></el-input>
      </el-form-item> 

    </el-form>
     <el-button type="primary" @click="save">保存</el-button>
     <Backfooter></Backfooter>
    </div>
</template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
  data() {
    return {
      contForm: {
        id:1,
        content: '', 
        content_en: '', 
        image_one: '', 
        image_two: '', 
      },
      location: '',
      headers: {
        Authorization: ''
      }
    }
  },
  methods: {
    upImgSuccessone(response) {
      // console.log(response)
      this.contForm.image_one = 'https://api.treegroup-inc.com/' + response.data.url
      // console.log(this.contForm.image_one)
    },
    upImgSuccesstwo(response) {
      // console.log(response)
      this.contForm.image_two = 'https://api.treegroup-inc.com/' + response.data.url
      // console.log(this.contForm.image_two)
    },
    save() {
      this.$http
        .post('/admin/dashu/joins/update', {
          id: this.contForm.id,
          content: this.contForm.content,
          content_en: this.contForm.content_en,
          image_one: this.contForm.image_one,
          image_two: this.contForm.image_two
        })
        .then(res => {
          var code = res.data.code
          if (code === 0) {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
          } else if (code === -1) {
            this.$message.error('请检查是否填写完整！')
          }
        })
        .catch(function(error) {
          //  console.log(error);
        })
    }
  },
  created() {
    this.headers.Authorization = window.localStorage.getItem('user_token')
    this.$http
      .post('/admin/dashu/joins/getList', {})
      .then(res => {
        // console.log(res.data.data.lists)
        var code = res.data.code
        if (code === 0) {
          this.contForm.content = res.data.data.lists.content
          this.contForm.content_en = res.data.data.lists.content_en
          this.contForm.image_one = res.data.data.lists.image_one
          this.contForm.image_two = res.data.data.lists.image_two
          //  console.log(this.contForm);
        }
      })
      .catch(function(error) {
        //  console.log(error);
      })
  }, 
}
</script>
<style scoped> 
.QR-code img{
  width: 400px;
  height: 250px;
}
.el-form-item {
    margin-bottom: 65px;
}
.dddiv{
  position: relative !important;
  padding-bottom: 100px !important;

}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/join.vue